namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.maximizable()
    @Serenity.Decorators.resizable()
    export class ApiScriptClassificheDialog extends Serenity.PropertyDialog<any, any> {
        protected getFormKey() { return ApiScriptClassificheForm.formKey; }

        protected form = new ApiScriptClassificheForm(this.idPrefix);

        constructor() {
            super();
        }

        /**
         * Here we override loadInitialEntity method to set value for "DisplayFieldValue" field.
         * If this was an EntityDialog, your field value would be originating from server side entity.
         */
        protected loadInitialEntity() {
            this.propertyGrid.load({
                VisualizzaApi: ''
            });
        }

        protected getDialogOptions() {
            var opt = super.getDialogOptions();
            opt.title = "API Script classifiche";
            opt.height = 600
            opt.width = 800;
            return opt;
        }

        protected getDialogButtons() {
            var buttons = super.getDialogButtons();

            // Add button
            buttons.unshift({
                text: 'Esporta',
                click: () => { /*Add Function Here */
                    var nIdProdotto = +(this.form.IdProdotto.value);
                    var nIdApi = +(this.form.IdApi.value);

                    if (nIdProdotto == 0) {
                        Q.notifyWarning("Selezionare il prodotto da utilizzare.")
                    }

                    if (nIdApi == 0) {
                        Q.notifyWarning("Selezionare l'API da utilizzare.")
                    }

                    //
                    var theDialog = new ApiScriptCodiceDialog();
                    theDialog.Codice = "Codice da inserire.";
                    theDialog.dialogOpen(false);
                }
            });

            // Remove button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "btn-primary"), 1);

            return buttons;
        }
    }
}
